import { postCTA } from '../../utils/appBridge'
import { getUpdateAppCTA } from '../../utils/utils'
import GenericRiveComponent from '../elite/GenericRiveComponent'
import Button from '../ui-components/Button'
import BottomSheetContent from './BottomSheetContent'

const UpgradeAppContent = ({ onDismiss }: { onDismiss: () => void }) => {
  return (
    <BottomSheetContent
      onDismiss={() => null}
      bottomSheetCtas={
        <UpgradeCTAs
          onUpgradeApp={() => {
            postCTA(JSON.stringify(getUpdateAppCTA()))
          }}
          onDismiss={onDismiss}
        />
      }
    >
      <div className='flex flex-col overflow-hidden'>
        <div className='pt-2 pb-4 flex justify-center'>
          <div className='w-[235px] h-[190px]'>
            <GenericRiveComponent riveUrl='/rives/upgrade_app.riv' riveState='Timeline 1' riveFit='fitWidth' />
          </div>
        </div>
        <div className='text-[#232323] text-[22px] font-[500] pb-3 text-center'>Update app to explore Elite</div>
        <div className='text-[#6A6E6E] font-[400] text-[14px] text-center'>
          Looks like you're on an older version. <br /> Update now for the full Elite experience.
        </div>
      </div>
    </BottomSheetContent>
  )
}

const UpgradeCTAs = ({ onUpgradeApp, onDismiss }: { onUpgradeApp: () => void; onDismiss: () => void }) => {
  return (
    <div className='flex flex-col gap-4 w-full'>
      <div>
        <Button
          buttonClassName='!min-h-[58px] w-full !bg-[#232323] rounded-xl text-white text-[16px]'
          isFullWidth
          onClick={onUpgradeApp}
        >
          Update App
        </Button>
      </div>
      <div onClick={onDismiss} className='underline h-10 flex justify-center items-center text-[#232323] font-[500]'>
        Go back
      </div>
    </div>
  )
}

export default UpgradeAppContent
